export const superReaderRepository: {
  active?: boolean;
} = {};
